<!--
 * @Author: ZhaoDong
 * @Date: 2022-10-24 19:26:22
 * @LastEditors: ZhaoDong
 * @LastEditTime: 2022-11-04 19:19:34
 * @Description: 其他设置
-->
<template>
  <a-form-model ref="ruleForm" labelAlign="right" :model="form" :rules="rules" :label-col="{ span: 4 }"
                :wrapper-col="{ span: 16 }">
    <!-- <h3 class="label_h3">其他设置</h3> -->
    <a-divider orientation="left">其他设置</a-divider>
    <a-row>
      <a-col :span="12">
        <a-form-model-item label="费用承担方" prop="money_from">
          <a-select placeholder="请选择费用承担方" :default-value="[]" v-model="form.money_from" :options="bearerOptions">
          </a-select>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <a-form-model-item label="退款退券" prop="refund_rule">
          <a-radio-group v-model="form.refund_rule">
            <div class="small-form-item">
              <a-radio value="1">退款不返还优惠券</a-radio>
            </div>
            <div class="small-form-item">
              <a-radio value="2">订单退款或取消时，退还优惠券
                <span class="gray-text-7">(多个订单使用同一张优惠券时，需全部订单退还才会退回优惠券）</span>
              </a-radio>
            </div>
          </a-radio-group>
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col :span="12">
        <a-form-model-item label="排序值" prop="coupon_sort">
          <a-input-number style="width:140px;margin-right:8px;" v-model="form.coupon_sort" allowClear :min="0"
                          :max="1000" placeholder="0-1000整数" :precision="0" />
          <span class="gray-text-7" style="line-height: 18px;">排序值仅影响活动页面领取时，优惠券的先后展示顺序</span>
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
import { pick } from 'lodash'

export default {
  data() {
    return {
      form: {
        money_from: '2', // 费用承担方 1官方承担（不减少销售业绩） 2业务承担（减少销售业绩）
        refund_rule: '1', // 退款退券 1退款不返还优惠券 2订单退款或取消时，退还优惠券
        coupon_sort: undefined // 排序
      },
      rules: {
        money_from: [{ required: true, message: '请选择费用承担方', trigger: ['change'] }],
        refund_rule: [{ required: true, message: '请选择退款退券', trigger: ['change'] }]
      },
      mutexRules: [{ label: '不可与其他优惠叠加使用', value: 0 }],
      bearerOptions: [
        // { label: '官方承担（不减少销售业绩）', value: '1' },
        { label: '业务承担（减少销售业绩）', value: '2' }
      ]
    }
  },
  methods: {
    async validate() {
      const valid = await this.$refs['ruleForm'].validate()
      return valid
    },
    /**
     * 自定义校验空值
     * @return Promise<true|false>
     */
    validNotEmptyFields() {
      return Promise.resolve(true)
    },
    async getValue(valid) {
      return new Promise((resolve, reject) => {
        if (valid) {
          this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
              resolve({ ...this.form })
            } else {
              reject(new Error('valid fail'))
            }
          })
        } else {
          resolve({ ...this.form })
        }
      })
    },
    setValue(data) {
      const _formData = pick.apply(undefined, [data].concat(Object.keys(this.form)))
      _formData.money_from = '' + _formData.money_from === '0' ? undefined : _formData.money_from
      this.form = _formData
    },
    resetForm() {
      this.$refs['ruleForm'].resetFields()
    }
  },
  components: {}
}
</script>

<style scoped lang="less">

</style>
